//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminEventController_findMembershipJournal,
  Response$AdminEventController_findMembershipJournal$Status$200,
  ResponseContentType$AdminEventController_findMembershipJournal,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminEventController_findMembershipJournal = (options: {
  params: Params$AdminEventController_findMembershipJournal['parameter'];
  config?: QueryOptions<
    Response$AdminEventController_findMembershipJournal$Status$200[ResponseContentType$AdminEventController_findMembershipJournal]
  >;
}) =>
  useApiClient<
    Params$AdminEventController_findMembershipJournal,
    Response$AdminEventController_findMembershipJournal$Status$200[ResponseContentType$AdminEventController_findMembershipJournal]
  >({
    method: 'AdminEventController_findMembershipJournal',
    params: { parameter: options.params },
    config: options.config,
  });
